// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-7c8a8444] .scan-dialog .el-dialog__body {\n  max-height: 100vh !important;\n}", ""]);
// Exports
module.exports = exports;
